module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0106.jpg?v=a8eb5c4a";